export default __webpack_public_path__ + "static/media/raw.548fe866.svg";